export const RATES_REQUESTED = 'RATES_REQUESTED';
export const RATES_SUCCESS = 'RATES_SUCCESS';
export const RATES_FAILED = 'RATES_FAILED';
